export default function getInstallationMode() {
    if (
        typeof process !== 'undefined' &&
        typeof process.env !== 'undefined' &&
        typeof process.env.REACT_APP_INSTALLATION_MODE !== 'undefined'
    )
        return process.env.REACT_APP_INSTALLATION_MODE;
    return 'unknown';
}